<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>金华觉远创智科技有限公司</h3>
        <p>地址：浙江省金华市</p>
        <p>邮箱：service@jueyuantech.com</p>
      </div>
      <div class="footer-section">
        <h3>快速导航</h3>
        <div>
          <a href="#">首页</a>
          <a href="#">产品介绍</a>
          <a href="#">关于我们</a>
        </div>
      </div>
      <div class="footer-section">
        <h3>最新动态</h3>
        <div>
          <a href="#">产品展示</a>
          <a href="#">新闻资讯</a>
          <a href="#">联系我们</a>
        </div>
      </div>
      <div class="footer-section">
        <h3>关注我们</h3>
        <div class="social-icons">
          <a href="#" class="social-icon">微信</a>
          <a href="#" class="social-icon">微博</a>
          <a href="#" class="social-icon">抖音</a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p><a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgba(255, 255, 255, 0.5); text-decoration: none;">浙ICP备2024115189号-1</a></p>
      <p>© 2025 copyright jueyuantech</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: #111;
  color: #fff;
  position: relative;
  padding: 96px 0 48px;
}

.footer:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #42b983;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 96px;
  gap: 48px;
}

.footer-section {
  flex: 1;
}

.footer-section h3 {
  color: #42b983;
  margin-bottom: 32px;
  font-size: 18px;
  font-weight: 500;
}

.footer-section p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 16px;
  font-size: 18px;
  line-height: 1.5;
}

.footer-section a {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  margin-bottom: 16px;
  font-size: 18px;
  transition: color 0.3s;
  line-height: 1.5;
}

.footer-section a:hover {
  color: #42b983;
}

.social-icons {
  display: flex;
  gap: 32px;
}

.social-icon {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s;
  font-size: 20px;
}

.social-icon:hover {
  color: #42b983;
}

.footer-bottom {
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.5);
}

@media screen and (max-width: 768px) {
  .footer {
    padding: 64px 0 32px;
  }

  .footer-content {
    flex-direction: column;
    padding: 0 32px;
    gap: 48px;
  }

  .footer-section {
    text-align: left;
    padding: 0 16px;
  }

  .footer-section h3 {
    margin-bottom: 24px;
    font-size: 30px;
  }

  .footer-section p {
    margin-bottom: 16px;
    font-size: 26px;
  }

  /* 快速导航和最新动态部分的链接横向排列 */
  .footer-section:nth-child(2),
  .footer-section:nth-child(3) {
    display: flex;
    flex-direction: column;
  }

  .footer-section:nth-child(2) > div,
  .footer-section:nth-child(3) > div {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 32px;
  }

  .footer-section a {
    margin-bottom: 0;
    font-size: 26px;
    flex: 0 0 auto;
  }

  .social-icons {
    justify-content: flex-start;
    gap: 48px;
    flex-wrap: wrap;
  }

  .social-icon {
    font-size: 26px;
  }

  .footer-bottom {
    margin-top: 48px;
    padding: 24px 32px 0;
  }

  .footer-bottom p {
    font-size: 24px;
  }
}
</style> 